import React, { useEffect } from "react";
import AppNavbar from "../components/home/Navbar";
import { Container } from "react-bootstrap";
import Footer from "../components/footer/Footer";
import Seo from "../components/seo/Seo";
import { PAGES } from "../content/pages";

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Seo {...PAGES.terms} />
      <AppNavbar />
      <Container style={{ padding: "20px", justifyItems: "center" }}>
        <h2 style={{ color: "#051259" }}>
          Conditions Générales d’Utilisation (CGU)
        </h2>

        <h5 style={{ marginBottom: "40px" }}>
          PLATFORM98 est — Accompagnement juridique, administratif et commercial
        </h5>

        <div style={{ textAlign: "left", maxWidth: "1000px" }}>
          <h4 style={{ color: "#FF5500" }}>Généralités :</h4>
          <p>
            La société PLATFORM98 rappelle qu’elle ne fournit aucun service
            relevant de la consultation juridique, de la rédaction d’actes sous
            seing privé pour autrui ou de la représentation en justice,
            activités réservées aux avocats conformément à la loi. PLATFORM98
            propose uniquement des prestations d’accompagnement administratif et
            de gestion de tâches, sans se substituer à un conseil juridique.
          </p>
          <p>
            Les documents, modèles et formulaires mis à disposition par
            PLATFORM98 sont fournis à titre informatif et standard. Ils ne
            constituent en aucun cas des documents personnalisés ou adaptés à la
            situation juridique, administrative ou fiscale propre à chaque
            utilisateur.
          </p>
          <p>
            Il appartient à l’utilisateur de s’assurer de l’adéquation des
            modèles à sa situation particulière, notamment en sollicitant, si
            nécessaire, les conseils d’un professionnel qualifié (avocat,
            notaire, expert-comptable, etc.).
          </p>
          <p>
            En conséquence, la responsabilité de PLATFORM98 ne saurait être
            engagée en cas de dommages directs ou indirects, matériels ou
            immatériels, résultant de l’utilisation, de la mauvaise
            interprétation ou de l’inadéquation d’un modèle fourni.
          </p>
          <p>
            L’utilisateur est toute personne ayant accès au site. Lorsque le
            service fourni est payant, toute stipulation à l’utilisateur doit
            s’entendre comme le client.
          </p>
          <p>
            Le client est celui qui sollicite des services payants.
            <br /> Qu’ils s’agissent de l’un ou de l’autre, ils restent soumis
            aux présentes CGU.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 1 : Objet et champ d’application
          </h4>

          <p>
            Les présentes Conditions Générales d’Utilisation (CGU) définissent
            les modalités et conditions dans lesquelles la société PLATFORM98
            met à disposition de ses utilisateurs l’ensemble de ses services
            accessibles via sa plateforme numérique ainsi que ses prestations
            physiques. Elles régissent les relations contractuelles entre
            PLATFORM98 et toute personne accédant ou utilisant ses services,
            qu’il s’agisse d’un particulier ou d’une entreprise. En accédant aux
            services de PLATFORM98, l’utilisateur accepte pleinement et sans
            réserve les présentes CGU.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 2 : Identification de PLATFORM98
          </h4>

          <p>
            PLATFORM98 est une Société à Responsabilité Limitée Unipersonnelle
            (SARL-U) de droit camerounais, au capital social de neuf cent
            quatre-vingt-dix-neuf mille neuf cent quatre-vingt-dix-neuf
            (999.999) Francs CFA. Son siège social est établi au Boulevard de la
            République, Akwa — Douala. Elle est immatriculée au Registre du
            Commerce et du Crédit Mobilier sous le numéro RCCM
            CM-DLA-03-2025-B13-00207. <br /> BP : 15644
            <br />
            Téléphone : +237 651 990 766 / +237 689 821 350 <br />
            E-mail : contact@platform98.com
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 3 : Description des services
          </h4>
          <p>
            PLATFORM98 propose aux utilisateurs un ensemble de prestations
            destinées à faciliter la gestion administrative, juridique et
            commerciale des entreprises, parmi lesquelles :
          </p>
          <ul>
            <li>L’accompagnement à la création d’entreprise;</li>
            <li>La domiciliation juridique d’entreprises;</li>
            <li>
              Les services de gestion d’entreprise et d’optimisation
              administrative;
            </li>
            <li>
              La gestion des ressources humaines et la fourniture d’outils RH ;
            </li>
            <li>Le suivi juridique et la veille réglementaire ;</li>
            <li>
              L’accompagnement dans les formalités administratives diverses ;
            </li>
            <li>
              L’assistance et la rédaction d’actes commerciaux et juridiques.
            </li>
          </ul>
          <p>
            La société PLATFORM98 s’engage à fournir ses services avec diligence
            et professionnalisme, dans le cadre d’une obligation de moyens.
            Toutefois, sa responsabilité ne saurait être engagée qu’en cas de
            faute prouvée et exclusivement pour les dommages directs subis par
            le client, à l’exclusion de tout dommage indirect, immatériel ou
            consécutif, tel que perte de chiffre d’affaires, perte
            d’opportunité, perte de données ou atteinte à l’image.
          </p>
          <p>
            Le client reconnaît avoir été pleinement informé de la nature et des
            limites des services proposés par PLATFORM98, lesquels sont purement
            administratifs et organisationnels, et ne constituent en aucun cas
            des prestations juridiques relevant des professions réglementées
            telles qu’avocat ou expert-comptable. L’ensemble de ces services est
            accessible via une interface sécurisée, soumise aux présentes CGU.
          </p>

          <h4 style={{ color: "#FF5500" }}>Article 4 : Accès aux services</h4>
          <p>L’accès aux services proposés par PLATFORM98 est réservé :</p>
          <ul>
            <li>
              Aux personnes physiques majeures et juridiquement capables selon
              la législation au Cameroun
            </li>
            <li>
              Aux personnes morales, représentées par une personne dûment
              habilitée à cet effet.
            </li>
          </ul>
          <p>
            L’accès aux services suppose la création préalable d’un compte
            utilisateur personnel, protégé par un identifiant et un mot de
            passe. <br /> L’utilisateur s’engage à garantir la confidentialité
            de ses identifiants et à informer sans délai PLATFORM98 de toute
            utilisation non autorisée ou frauduleuse de son compte. Une fois le
            compte activé, l’utilisateur devra suivre les étapes indiquées sur
            la plateforme, selon le service souhaité.
            <br /> Les services proposés pourront être :
          </p>

          <ul>
            <li>
              Gratuits, tels que l’accès à la newsletter, documents
              d’information, contenus de présentation ;
            </li>
            <li>
              Payants, notamment sous forme d’abonnement ou de souscription à
              des prestations spécifiques.
            </li>
          </ul>

          <p>
            PLATFORM98 se réserve le droit, à sa seule discrétion, de refuser
            l’accès à ses services ou de suspendre un compte utilisateur en cas
            de violation des présentes Conditions Générales d’Utilisation.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 5 : Informations collectées
          </h4>

          <h5 style={{ color: "#FF5500" }}>5-1 : Informations personnelles</h5>

          <p>
            Nous pouvons collecter des informations personnelles lorsque vous :
          </p>

          <ul>
            <li>Créez un compte.</li>
            <li>Remplissez un formulaire de contact.</li>
            <li>Effectuez une transaction ou un paiement.</li>
            <li>Interagissez avec notre service client.</li>
          </ul>

          <p>
            Les informations collectées peuvent inclure, mais ne sont pas
            limitées à :
          </p>

          <ul>
            <li>Nom</li>
            <li>Adresse e-mail</li>
            <li>Numéro de téléphone</li>
            <li>Adresse postale</li>
            <li>Informations de paiement</li>
          </ul>

          <h5 style={{ color: "#FF5500" }}>
            5.2 Informations non personnelles
          </h5>

          <p>
            Nous collectons également des informations non personnelles, telles
            que :
          </p>

          <ul>
            <li>
              Données d'utilisation (ex : pages visitées, temps passé sur le
              site).
            </li>
            <li>
              Informations sur l'appareil (ex : type d'appareil, système
              d'exploitation).
            </li>
            <li>Adresse IP</li>
          </ul>

          <h5 style={{ color: "#FF5500" }}>5.3 Utilisation des informations</h5>

          <p>Platform98 utilise les informations collectées pour :</p>

          <ul>
            <li>Fournir et gérer nos services.</li>
            <li>Traiter les transactions et envoyer des confirmations.</li>
            <li>
              Communiquer avec les utilisateurs concernant leur compte ou leurs
              demandes.
            </li>
            <li>
              Améliorer nos services et personnaliser l'expérience utilisateur.
            </li>
            <li>
              Envoyer des newsletters et des offres promotionnelles (avec
              consentement).
            </li>
          </ul>

          <h5 style={{ color: "#FF5500" }}>5.4 Protection des informations</h5>

          <p>
            Nous mettons en œuvre des mesures de sécurité appropriées pour
            protéger vos informations personnelles contre tout accès non
            autorisé, utilisation ou divulgation. Cela inclut l'utilisation de
            la technologie SSL pour sécuriser les données sensibles lors de la
            transmission.
          </p>

          <h5 style={{ color: "#FF5500" }}>5.5 Partage des informations</h5>

          <p>
            Platform98 ne vend ni ne loue vos informations personnelles à des
            tiers. Nous pouvons partager vos informations dans les cas suivants
            :
          </p>

          <ul>
            <li>
              Avec des prestataires de services tiers qui nous aident à fournir
              nos services (ex : traitement des paiements).
            </li>
            <li>
              Pour se conformer à la loi ou répondre à des demandes légales.
            </li>
            <li>Dans le cadre d'une fusion, acquisition ou vente d'actifs.</li>
          </ul>

          <h5 style={{ color: "#FF5500" }}>5.6 Vos droits</h5>

          <p>Vous avez le droit de :</p>

          <ul>
            <li>
              - Accéder à vos informations personnelles que nous détenons.
            </li>
            <li>- Demander la correction ou la suppression de vos données.</li>
            <li>
              - Retirer votre consentement à l'utilisation de vos données à des
              fins marketings. Pour exercer ces droits, veuillez nous contacter
              via les coordonnées fournies ci-dessous : <br />{" "}
              support@platform98.com
            </li>
          </ul>

          <h4 style={{ color: "#FF5500" }}>
            Article 6 : Engagements de l’utilisateur
          </h4>

          <p>
            L’utilisateur s’engage à utiliser les services de PLATFORM98 dans le
            strict respect :
          </p>
          <ul>
            <li>
              Des lois et règlements en vigueur en République du Cameroun.
            </li>
            <li>
              Des règles de bonne conduite en ligne, notamment l’interdiction
              d’introduire des virus, malwares ou toute autre technologie
              nuisible sur la plateforme.
            </li>
            <li>
              De fournir des informations exactes, sincères et régulièrement
              mises à jour, notamment lors de la création d’un compte client.
            </li>
          </ul>

          <p>
            Toute utilisation frauduleuse, abusive ou contraire à l’ordre public
            pourra entraîner des sanctions allant de la simple mise en demeure à
            la résiliation immédiate des services ou sanctions pécuniaires.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 7 : Engagements de l’utilisateur
          </h4>

          <p>
            Les parties conviennent expressément que, sauf mention contraire
            précisée dans le présent contrat, PLATFORM98 est soumis à une
            obligation de moyens.
            <br /> PLATFORM98 s’engage à mobiliser toutes les ressources,
            compétences et diligences raisonnables pour exécuter les prestations
            prévues au contrat, conformément aux règles de l’art et aux usages
            professionnels en vigueur.
            <br /> Lorsque le contrat mentionne explicitement une obligation de
            résultat pour une prestation déterminée, PLATFORM98 sera tenu
            d’atteindre le résultat spécifié, sauf cas de force majeure ou faute
            imputable au client.
            <br /> Aucune garantie implicite ne saurait être déduite de la
            nature des services fournis sans stipulation expresse, notamment
            s’agissant de démarches administratives dépendant d’autorités
            tierces, pour lesquelles PLATFORM98 ne saurait garantir un délai ni
            une issue favorable.
            <br />
            PLATFORM98 garantit notamment :
          </p>

          <ul>
            <li>
              La mise en œuvre de moyens humains et techniques raisonnables pour
              assurer le bon fonctionnement de ses services ;
            </li>
            <li>
              La sécurité des données personnelles et commerciales traitées,
              conformément aux normes en vigueur ;
            </li>
            <li>
              La confidentialité des échanges et des documents transmis par
              l’utilisateur ;
            </li>
            <li>
              L’accompagnement dans la régularisation des formalités juridiques,
              sous réserve des délais administratifs et de la bonne transmission
              des informations par le client.
            </li>
          </ul>

          <p>
            PLATFORM98 se réserve le droit de sous-traiter certains services,
            dans le respect des normes contractuelles et légales.
          </p>

          <h4 style={{ color: "#FF5500" }}> Article 8 : Responsabilités</h4>

          <p>PLATFORM98 ne pourra être tenue responsable :</p>

          <ul>
            <li>
              - Des retards imputables aux tiers, administrations publiques,
              institutions bancaires ou organismes partenaires ;
            </li>
            <li>
              - Des interruptions de service dues à une maintenance ou à un cas
              de force majeure tel que défini par la législation camerounaise ;
            </li>
            <li>
              - D’un préjudice indirect, commercial ou financier subi par
              l’utilisateur suite à l’utilisation des services.
            </li>
          </ul>

          <p>
            La responsabilité de PLATFORM98 est strictement limitée au montant
            des sommes versées par l’utilisateur pour le service en cause.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 9 : Conventions et régimes juridiques applicables
          </h4>

          <p>
            Certains services proposés par PLATFORM98 sont soumis à des régimes
            juridiques ou conventions spécifiques, notamment dans les domaines :
          </p>

          <ul>
            <li>
              Du droit du travail (ex. contrats de travail, formalités CNPS,
              gestion des employés) ;
            </li>
            <li>
              Du droit commercial (contrats de prestation, statuts de sociétés,
              cessions de parts) ;
            </li>
            <li>
              Du droit fiscal (déclarations, immatriculation, fiscalité des
              entreprises) ;
            </li>
            <li>
              Du droit des étrangers (demandes de visas professionnels,
              autorisations de travail, etc.).
            </li>
          </ul>

          <p>
            PLATFORM98 fournit uniquement des modèles standards et agit
            conformément aux conventions et usages en vigueur, mais
            l’utilisateur reste entièrement responsable de la véracité des
            informations transmises et du respect final des obligations légales.
            Le client doit s’assurer que les modèles fournis sont adaptés à sa
            situation spécifique, ou révisés selon les lois, conventions et
            règlements applicables.
          </p>

          <h4 style={{ color: "#FF5500" }}>Article 10 : Formalités diverses</h4>

          <p>
            PLATFORM98 peut se voir confier, par mandat exprès ou tacite,
            l’exécution de formalités administratives, notamment :
          </p>

          <ul>
            <li>
              Dépôt ou retrait de documents auprès des administrations (Greffe,
              Impôts, CNPS, etc.) ;
            </li>
            <li>
              Suivi de demandes de création, modification ou radiation
              d'entreprise ;
            </li>
            <li>
              Obtention d’autorisations, certificats, licences ou numéros
              fiscaux ;
            </li>
            <li>Règlement de frais administratifs auprès d’entités tierces.</li>
          </ul>

          <p>
            Le succès de ces démarches dépend en partie des délais de traitement
            des administrations concernées. PLATFORM98 s'engage à diligenter les
            formalités dans les délais raisonnables, mais ne garantit pas les
            délais de délivrance des autorités publiques.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 11 : Abonnements et formules de services
          </h4>

          <p>
            PLATFORM98 propose des services accessibles selon deux modalités :
          </p>

          <ul>
            <li>
              À l’acte : prestations ponctuelles, facturées selon un tarif
              forfaitaire ;
            </li>
            <li>
              Par abonnement : accès à un ensemble de services pour une durée
              déterminée.
            </li>
          </ul>

          <p>
            Les abonnements souscrits auprès de PLATFORM98 sont conclus pour une
            durée déterminée, précisée lors de la souscription. Ils ne font pas
            l’objet d’un renouvellement automatique à leur échéance. À
            l’expiration de l’abonnement, les services correspondants prennent
            fin, sauf nouvelle souscription par l’utilisateur.
            <br /> L’utilisateur peut à tout moment consulter son espace
            personnel pour suivre l’état de son abonnement et souscrire à une
            nouvelle offre s’il le souhaite.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 12 : Stipulations financières
          </h4>

          <h5 style={{ color: "#FF5500" }}>12.1 Tarifs</h5>

          <p>
            Les prix des prestations sont indiqués en Francs CFA (XAF) et toutes
            taxes comprises (TTC). PLATFORM98 se réserve le droit de modifier
            ses tarifs à tout moment, les prix applicables étant ceux en vigueur
            au jour de la commande ou de la souscription.
          </p>

          <h5 style={{ color: "#FF5500" }}>12.2 Les paiements</h5>

          <p>
            Le paiement des prestations s’effectue à la commande ou selon les
            échéances prévues pour les abonnements. Toute somme non payée à son
            échéance entraînera, après mise en demeure, des pénalités de retard
            calculées selon le taux légal en vigueur au Cameroun.
          </p>

          <h5 style={{ color: "#FF5500" }}>
            12.3 Facturation et justificatifs
          </h5>

          <p>
            Une facture est émise automatiquement pour chaque transaction.
            L’utilisateur peut la consulter et la télécharger depuis son espace
            client.
          </p>

          <h5 style={{ color: "#FF5500" }}>12.4 Remboursement</h5>

          <p>
            Aucun remboursement n’est possible une fois que la prestation a
            débuté, sauf en cas d’inexécution fautive imputable à PLATFORM98.
            Les abonnements ne sont pas remboursables sauf cas exceptionnels
            dûment justifiés.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 13 : Prestataires de paiement
          </h4>

          <p>
            PLATFORM98 confie la gestion des paiements à des prestataires tiers
            spécialisés et agréés (ex. : Orange Money, MTN Mobile Money, banques
            locales, ou prestataires internationaux conformes à la
            réglementation BEAC).
            <br /> Ces prestataires assurent :
          </p>

          <ul>
            <li>La sécurité des transactions via chiffrement SSL/TLS ;</li>
            <li>
              La conformité avec les normes PCI-DSS en matière de traitement des
              données bancaires ;
            </li>
            <li>
              Le respect des obligations de lutte contre le blanchiment des
              capitaux et le financement du terrorisme.
            </li>
          </ul>

          <p>
            PLATFORM98 n’enregistre à aucun moment les données bancaires
            complètes de l’utilisateur. Tout litige relatif à une transaction
            devra d’abord être signalé au prestataire de paiement concerné,
            puis, si besoin, à PLATFORM98.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 14 : upgrade des souscriptions
          </h4>

          <p>
            PLATFORM98 s’engage à garantir une expérience fluide et transparente
            à ses utilisateurs souhaitant améliorer leur niveau de service. Tous
            les utilisateurs ayant une souscription active peuvent demander un
            upgrade vers un plan supérieur ou un service additionnel, sous
            réserve de respecter les conditions suivantes :
          </p>

          <ul>
            <li>
              La souscription actuelle doit être en règle, sans paiements en
              retard.
            </li>
            <li>
              L'upgrade doit être demandé pour des services disponibles dans le
              cadre des offres de Platform98.
            </li>
          </ul>

          <p>Les upgrades peuvent inclure, mais ne sont pas limités à :</p>

          <ul>
            <li>
              Passage à un plan supérieur offrant plus de fonctionnalités.
            </li>
            <li>
              Ajout de services complémentaires (par exemple, services de
              comptabilité ou de gestion administrative).
            </li>
          </ul>

          <p>Pour effectuer une demande d'upgrade, le client doit :</p>

          <ul>
            <li>
              Contacter le service client par email ou directement y souscrire
              via nos formulaires en ligne.
            </li>
            <li>
              Indiquer clairement le type d'upgrade souhaité et fournir les
              informations nécessaires (numéro de souscription, détails du plan
              actuel, etc.).
            </li>
          </ul>

          <p>Une fois la demande reçue, Platform98 procédera à :</p>

          <ul>
            <li>La vérification de l'éligibilité du client pour l'upgrade.</li>
            <li>
              La confirmation des nouvelles conditions tarifaires et des
              fonctionnalités associées au plan supérieur.
            </li>
            <li>L’évaluation et le conseil concernant son besoin d’upgrade</li>
          </ul>

          <p>
            En cas d’ajustement des frais, la facturation et la tarification
            s’effectueront de la manière suivante :
          </p>

          <ul>
            <li>
              Facturation immédiate : En cas d'upgrade vers un plan supérieur,
              la différence de tarif sera facturée immédiatement au client.
            </li>
            <li>
              Prorata : Si l'upgrade est demandé en milieu de période de
              facturation, le montant sera ajusté au prorata en fonction du
              temps restant jusqu'à la fin de la période actuelle.
            </li>
          </ul>

          <p>
            Les clients peuvent choisir parmi plusieurs options de paiement pour
            régler les frais d'upgrade, y compris les paiements par carte
            bancaire, Mobile payement, paypal, etc. PLATFORM98 se réserve le
            droit de modifier à tout moment les Conditions Générales de
            souscription à un service ou d’upgrade.
            <br /> En cas de modification, l’Utilisateur en sera informé un mois
            avant l’entrée en vigueur, par tout moyen laissant trace et
            notamment par voie de publication sur la plateforme. En continuant à
            utiliser le Service, l’Utilisateur sera considéré comme ayant
            accepté les modifications des Conditions Générales de Tarification
            ou d’upgrade. Les clients qui effectuent un upgrade peuvent
            également choisir de modifier ou de résilier leur nouvelle
            souscription selon les conditions générales de résiliation
            applicables.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 15 : Coûts supplémentaires et révision des prix
          </h4>

          <h5 style={{ color: "#FF5500" }}>15.1 Variabilité des coûts</h5>

          <p>
            Les prix annoncés par PLATFORM98 incluent les frais standards connus
            à la date de souscription. Toutefois, certains frais administratifs,
            fiscaux ou notariaux peuvent être sujets à variation sans préavis,
            en raison de :
          </p>

          <ul>
            <li>Changements de réglementation ;</li>
            <li>
              Réévaluation des tarifs par les administrations compétentes ;
            </li>
            <li>Majoration des taxes ou droits exigibles.</li>
          </ul>

          <p>
            Dans ce cas, l’utilisateur sera informé en amont et devra
            s’acquitter des montants supplémentaires pour permettre la poursuite
            de la prestation.
          </p>

          <h5 style={{ color: "#FF5500" }}>15.2 Révision contractuelle</h5>

          <p>
            En cas de modification substantielle des coûts ou de l’environnement
            légal rendant l’exécution du contrat manifestement déséquilibrée,
            les parties conviennent de renégocier de bonne foi les conditions
            financières ou, à défaut d’accord, de résilier le contrat sans
            indemnité.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 16 : Droit de Rétractation
          </h4>

          <p>
            Conformément aux dispositions de la loi sur le commerce
            électronique, l’utilisateur dispose d’un délai de 15 jours à compter
            de la date de souscription au service, pour exercer son droit de
            rétractation sans motif ni pénalité, sauf si l’exécution du service
            a déjà débuté avec son accord préalable. Toute demande de
            rétractation doit être notifiée par écrit à l’adresse suivante :
            support@platform98.com. <br /> Les services suivants sont non
            remboursables et ne peuvent pas être annulés une fois engagés :
          </p>

          <ul>
            <li>
              Création d'entreprise : Les frais liés à la création d'entreprise
              sont considérés comme définitifs dès l'activation du service, car
              il s'agit de prestations personnalisées nécessitant une
              mobilisation immédiate de ressources.
            </li>
            <li>
              Formalités administratives diverses : Les paiements effectués pour
              la gestion de formalités administratives, y compris les démarches
              liées aux visas, sont également non remboursables en raison de la
              nature irréversible de ces services.
            </li>
          </ul>

          <p>
            Les clients doivent s'assurer de leur engagement avant de souscrire
            à ces services.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 17 : Annulation des autres souscriptions
          </h4>

          <p>
            L’utilisateur peut solliciter l'annulation d’une souscription sous
            les conditions suivantes :
          </p>

          <ul>
            <li>Si la prestation de service n’a pas encore débuté.</li>
            <li>
              Si le client formule la demande dans le délai légal de
              rétractation.
            </li>
            <li>
              Si l’annulation intervient hors délai, PLATFORM98 se réserve le
              droit de facturer des frais d’annulation correspondant aux
              démarches déjà entreprises ou aux frais engagés. Pour les services
              éligibles (autres que ceux mentionnés ci-dessus), les clients
              disposent d'un délai de 15 jours à compter de la date de
              souscription pour annuler leur contrat sans justification.
            </li>
          </ul>

          <h4 style={{ color: "#FF5500" }}>Article 18 : Remboursements</h4>

          <p>Les conditions générales de remboursement sont les suivantes : </p>

          <ul>
            <li>
              Services éligibles : Les remboursements sont possibles uniquement
              pour les services éligibles annulés dans le délai de rétractation.
            </li>
            <li>
              Services non éligibles : Aucun remboursement ne sera accordé pour
              les services liés à la création d'entreprise ou aux formalités
              administratives diverses, sauf en cas d'erreur avérée ou de
              non-conformité du service fourni.
            </li>
          </ul>

          <p>En cas d'annulation valide : </p>

          <ul>
            <li>
              Remboursement total si la demande est faite avant le début de la
              prestation et dans le délai de rétractation.
            </li>
            <li>
              Remboursement partiel en cas de commencement d’exécution avec
              accord du client, déduction faite des frais proportionnels aux
              services déjà fournis.
            </li>
            <li>
              - Aucun remboursement ne sera effectué si l’intégralité du service
              a été réalisée avant réception de la demande d'annulation.
            </li>
          </ul>

          <p>
            En cas d’annulation après la période de rétractation :<br /> Après
            le délai légal de rétractation, les souscriptions peuvent être
            annulées, mais aucun remboursement ne sera effectué pour la période
            déjà facturée. L'annulation prendra effet à la fin de la période en
            cours. <br /> Aucun remboursement ou compensation ne pourra être
            exigé en cas d’inexécution ou de retard causé par un événement de
            force majeure, tel que défini par le Code civil camerounais.
            <br /> Le remboursement s’effectuera par le même moyen de paiement
            utilisé lors de la souscription. Pour exercer ce droit le client
            doit : 1. Contacter le service client par email ou via notre
            formulaire en ligne. <br />
            2. Fournir les détails nécessaires (numéro de souscription, preuve
            de paiement, etc.). <br />
            3. Attendre la validation et le traitement de la demande. Les
            remboursements approuvés seront traités dans un délai maximum de 15
            jours ouvrables.
            <br /> Platform98 se réserve le droit de modifier cette politique à
            tout moment. Toute modification sera publiée sur notre site web et
            prendra effet immédiatement.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 19 : Restrictions techniques ou géographiques
          </h4>

          <p>
            Les services proposés par PLATFORM98 peuvent être soumis à certaines
            limitations légales en fonction du territoire concerné.
            <br /> À ce titre, les prestations suivantes sont encadrées par des
            restrictions géographiques spécifiques :
          </p>

          <ul>
            <li>
              Domiciliation d’entreprise : limitée aux États membres de l’OHADA.
            </li>
            <li>
              Administration d’entreprise : réservée aux entreprises ayant leur
              siège social sur le territoire camerounais.
            </li>
          </ul>

          <p>
            En ce qui concerne l’accomplissement des formalités administratives
            diverses, les restrictions s’appliquent comme suit :
          </p>

          <ul>
            <li>
              Modification des statuts : applicable aux entreprises
              immatriculées au Cameroun.
            </li>
            <li>
              Recouvrement de créances : limité au territoire camerounais.
            </li>
            <li>
              Formalités auprès de l’OAPI : applicables aux États membres de
              l’Organisation Africaine de la Propriété Intellectuelle (OAPI).
            </li>
            <li>
              Autorisation d’importation : valable uniquement sur le territoire
              camerounais.
            </li>
            <li>
              Divers permis : délivrés exclusivement sur le territoire
              camerounais.
            </li>
          </ul>

          <h4 style={{ color: "#FF5500" }}>
            Article 20 : Propriété intellectuelle
          </h4>

          <p>
            L’intégralité des éléments publiés sur la plateforme, y compris les
            marques, logos, chartes graphiques, textes, images, bases de
            données, ainsi que tout contenu audiovisuel ou rédactionnel, est
            protégée par le droit camerounais sur la propriété intellectuelle.{" "}
            <br />
            Toute reproduction, diffusion, modification ou exploitation
            commerciale sans autorisation écrite préalable constitue une
            violation des droits de PLATFORM98 et pourra donner lieu à des
            poursuites judiciaires.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 21 : Propriété intellectuelle
          </h4>

          <p>
            PLATFORM98 utilise, dans le cadre de certains services, des outils
            d’aide à la décision ou de génération de contenu reposant sur des
            technologies d’intelligence artificielle (IA). Ces outils peuvent
            notamment servir à :
          </p>

          <ul>
            <li>
              L’analyse automatisée de documents administratifs et juridiques ;
            </li>
            <li>
              La rédaction assistée de courriers ou de projets de contrats ;
            </li>
            <li>L’assistance virtuelle dans les démarches en ligne.</li>
          </ul>

          <p>
            L’utilisateur reconnaît que l’IA utilisée par PLATFORM98 agit comme
            outil d’assistance et non comme substitut à un conseil juridique
            personnalisé. PLATFORM98 s’engage à assurer une supervision humaine
            systématique pour toute prestation reposant sur de l’IA.
            <br /> En utilisant ces fonctionnalités, l’utilisateur accepte que
            certaines données puissent être traitées par des outils d’IA,
            hébergés de manière sécurisée, dans le respect de la loi n°2010/013
            relative à la protection des données à caractère personnel.
          </p>

          <h4 style={{ color: "#FF5500" }}>Article 22 : Cookies</h4>

          <p>
            Platform98 utilise des cookies pour améliorer l'expérience
            utilisateur sur notre site. Les cookies sont de petits fichiers
            stockés sur votre appareil qui nous aident à analyser le trafic et à
            personnaliser le contenu.
            <br /> Vous pouvez choisir d'accepter ou de refuser les cookies via
            les paramètres de votre navigateur. Cependant, cela peut affecter
            votre expérience sur notre site.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 23 : Modifications des CGU
          </h4>

          <p>
            PLATFORM98 se réserve le droit de modifier à tout moment les
            présentes CGU afin de tenir compte des évolutions législatives,
            réglementaires ou techniques. Les modifications seront notifiées par
            e-mail, ou lors de la prochaine connexion de l’utilisateur sur le
            site.
            <br /> En cas de refus des nouvelles CGU, l’utilisateur sera réputé
            renoncer à l’utilisation des services, entraînant la résiliation ou
            la suspension de son accès, conformément aux modalités d’annulation
            des souscriptions et de remboursement des paiements.
          </p>

          <h4 style={{ color: "#FF5500" }}>
            Article 24 : Droit applicable et juridiction compétente
          </h4>

          <p>
            Les présentes CGU sont régies par la législation en vigueur en
            République du Cameroun, notamment le Code civil, la Loi sur le
            commerce électronique, la Loi sur la protection des données
            personnelles, et la Loi sur la cyber sécurité.
            <br /> En cas de litige relatif à l’interprétation, l’exécution ou
            la validité des présentes CGU, les parties s’engagent à rechercher
            une solution amiable.
            <br /> À défaut d’accord, compétence exclusive est attribuée aux
            juridictions du ressort du siège social de PLATFORM98.
          </p>
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default TermsAndConditions;
